<div class="modal-body" style="overflow:hidden;">

  <div style="display: flex; justify-content: center; margin-bottom: 32px;">
    <img style="width: 500px;" src="../../../../../assets/secure-stripe-payment-logo.png" alt="" />
  </div>
  <div class="product-details">
    <div class="row">
      <div class="col-6">Bundle</div>
      <div class="col-3">Credits</div>
      <div class="col-3">Price</div>
    </div>
    <div class="row">
      <div class="col-6">{{bundle.packageDescription}}</div>
      <div class="col-3">{{bundle.credits}}</div>
      <div class="col-3">{{bundle.currencySymbol}}{{bundle.amount | number : '.2-2'}}</div>
    </div>
    <hr />
    <div class="row">
      <div class="col-6">Total</div>
      <div class="col-3"></div>
      <div class="col-3">{{bundle.currencySymbol}}{{bundle.amount | number : '.2-2'}}</div>
    </div>
  </div>

  <div class="">
    <div class="cell card-container card1" id="card-1">
      <form id="payment-form">
        <fieldset>
          <div class="row">
            <div id="card-input"></div>
          </div>
        </fieldset>
      </form>
    </div>
    <div class="card-error" *ngIf="error && error.message">
      {{error.message}}
    </div>
    <div style="display: flex">
      <button pButton id="submit_button" (click)="submitPayment()" [disabled]="busy" label="Submit Payment"></button>
      <button pButton id="cancel_button" (click)="modal.dismiss()" label="Cancel"></button>
    </div>
  </div>
  <div *ngIf="busy">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
      animationDuration=".5s">
    </p-progressSpinner>
  </div>

</div>